import { render, staticRenderFns } from "./DefaultTranscriptPdf.vue?vue&type=template&id=1519a496&"
import script from "./DefaultTranscriptPdf.vue?vue&type=script&lang=js&"
export * from "./DefaultTranscriptPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports